'use client'

import { type ReactNode, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Provider } from 'react-redux'
import { type Persistor, persistStore } from 'redux-persist'

import { getSidebarsCookie } from '@/utils/cookieUtil'

import { makeStore } from './store'
import { viewActions } from './view'

type Props = {
  children: ReactNode
}

export const ReduxProvider = ({ children }: Props) => {
  const [store] = useState(() => makeStore())
  const persistor = useRef<Persistor | null>(null)

  useLayoutEffect(() => {
    store.dispatch(viewActions.initSidebars(getSidebarsCookie()))
  }, [store])

  useEffect(() => {
    persistor.current ??= persistStore(store, null, () => store.dispatch(viewActions.setRehydrated()))
  }, [store])

  return <Provider store={store}>{children}</Provider>
}
